export default __webpack_public_path__ + "static/media/bg_admin.308faa8c.jpg";